import * as React from 'react';
export const ShootingStarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="#A84DFF"
      d="M18.7 5.475a1.048 1.048 0 0 0-.92-.725l-2.886-.228-1.11-2.63a1.055 1.055 0 0 0-1.942 0l-1.11 2.63-2.886.228a1.046 1.046 0 0 0-.599 1.842l2.192 1.85-.668 2.765a1.04 1.04 0 0 0 .398 1.087 1.055 1.055 0 0 0 1.172.054l2.472-1.489 2.473 1.49a1.058 1.058 0 0 0 1.535-.538c.07-.193.082-.403.034-.603l-.669-2.765 2.192-1.85a1.04 1.04 0 0 0 .322-1.118Zm-3.615 2.26a.625.625 0 0 0-.204.624l.647 2.673-2.393-1.438a.625.625 0 0 0-.644 0l-2.392 1.44.647-2.675a.626.626 0 0 0-.205-.625L8.438 5.958l2.775-.22a.625.625 0 0 0 .526-.38l1.074-2.553 1.077 2.553a.625.625 0 0 0 .527.38l2.775.22-2.107 1.776ZM6.882 9.622l-4.564 4.57a.625.625 0 1 1-.885-.885L6 8.74a.625.625 0 1 1 .884.885l-.002-.003Zm.844 3.897a.625.625 0 0 1 0 .883l-4.158 4.164a.626.626 0 0 1-.885-.884l4.162-4.161a.625.625 0 0 1 .883 0l-.002-.002Zm5.703-.079a.625.625 0 0 1 0 .885l-4.24 4.24a.625.625 0 1 1-.885-.884l4.242-4.24a.625.625 0 0 1 .887 0h-.004Z"
    />
  </svg>
);
